import styled, { css } from 'styled-components';
import { themeGet } from '../../v2/foundation/theme/themeGet/get.js';
import { fontSize } from '../../theme/typography/fontSize.js';
import { fontWeight } from '../../theme/typography/fontWeight.js';
import { interactiveTransition } from '../../v2/foundation/theme/utils.js';
import { padding, unit } from '../../v2/foundation/spacing/utils.js';

var appearanceColors = {
  "default": {
    color: themeGet('colors.gray.500'),
    background: themeGet('colors.gray.50')
  },
  disabled: {
    color: themeGet('colors.gray.400'),
    background: themeGet('colors.gray.50')
  },
  primary: {
    color: themeGet('colors.primary.500'),
    background: themeGet('colors.primary.50')
  },
  secondary: {
    color: themeGet('colors.cyan.500'),
    background: themeGet('colors.cyan.50')
  },
  info: {
    color: themeGet('colors.blue.600'),
    background: themeGet('colors.blue.50')
  },
  success: {
    color: themeGet('colors.green.600'),
    background: themeGet('colors.green.50')
  },
  danger: {
    color: themeGet('colors.red.600'),
    background: themeGet('colors.red.50')
  },
  destructive: {
    color: themeGet('colors.red.600'),
    background: themeGet('colors.red.50')
  },
  warning: {
    color: themeGet('colors.yellow.800'),
    background: themeGet('colors.yellow.50')
  },
  blue: {
    color: themeGet('colors.blue.600'),
    background: themeGet('colors.blue.50')
  },
  green: {
    color: themeGet('colors.green.600'),
    background: themeGet('colors.green.50')
  },
  red: {
    color: themeGet('colors.red.600'),
    background: themeGet('colors.red.50')
  },
  yellow: {
    color: themeGet('colors.yellow.800'),
    background: themeGet('colors.yellow.50')
  },
  magenta: {
    color: themeGet('colors.magenta.600'),
    background: themeGet('colors.magenta.50')
  },
  teal: {
    color: themeGet('colors.cyan.500'),
    background: themeGet('colors.cyan.50')
  },
  orange: {
    color: themeGet('colors.orange.600'),
    background: themeGet('colors.orange.50')
  },
  eyecatcher: {
    color: themeGet('colors.gray.0'),
    background: themeGet('colors.magenta.500')
  }
};
var stylesFromAppearance = function stylesFromAppearance(props) {
  var $appearance = props.$appearance;
  return css(["color:", ";background-color:", ";"], appearanceColors[$appearance].color, appearanceColors[$appearance].background);
};
var getPadding = function getPadding(props) {
  var $glyph = props.$glyph,
    $size = props.$size;
  if (!$glyph) {
    return padding(0, 2);
  }
  switch ($size) {
    case 'large':
      return css(["", ";"], padding(8));
    case 'medium':
      return css(["", ";"], padding(3.5));
    case 'small':
    default:
      return css(["", ""], padding(2));
  }
};
var getBorderRadius = function getBorderRadius(props) {
  var $glyph = props.$glyph,
    $size = props.$size;
  if (!$glyph) {
    return css(["border-radius:", ";"], unit(3));
  }
  switch ($size) {
    case 'large':
      return css(["border-radius:", ";"], unit(4));
    case 'medium':
      return css(["border-radius:", ";"], unit(3));
    case 'small':
    default:
      return css(["border-radius:", ";"], unit(2));
  }
};
var getHeight = function getHeight(props) {
  var $glyph = props.$glyph;
  if (!$glyph) {
    return unit(4);
  }
  return 'auto';
};
var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-1h6raw9-0"
})(["", ";", ";display:inline-flex;align-items:center;height:", ";", ";", ";", ";", ";"], fontSize('tiny', '1'), fontWeight('semibold'), getHeight, stylesFromAppearance, getPadding, getBorderRadius, interactiveTransition);

export { Container };
